import React from 'react';
import { Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Slider from './slider';
import SingleData from '../singleData';
import { TYPE_POSITIVE, TYPE_NEGATIVE, TYPE_INFORMATION } from '../constants';
import './index.css';

/**
 * Slider single data
 * Parameters (Props):
 * @param bool showBackgroundTitle = if this variable is false, then the title will
 *             have not a background color
 * @param bool basic
 * @param string color => not required (default none)
 * @param string backgroundColor => not required (default none and als background
 *               will be shown and gradient to red yellow blue)
 * @param string title => not required
 * @param number value => required initial value (must be between min and max)
 * @param string description
 * @param string unit  => not required: if unit is not empty, then it will be shown
 *               in the title and in the thumbDisplay. it should not be longer than 7 letters
 * @param number min => required the lowest value of the range
 * @param number max => required the highest value of the range
 * @param step step => not required (default 1)
 * @param bool inverted => not required if inverted = true, the color will be shown inverted
 * @param string type [positive | negative | information]
 * @param function onChange: this function will be called always that the value has been changed
 * @param array buttonsSliderComponent
 * @param string mode
 */
export default class SliderSingleData extends React.PureComponent {
  render() {
    const {
      showBackgroundTitle,
      basic,
      title,
      unit,
      value,
      description,
      color,
      inverted,
      step,
      onChange,
      backgroundColor,
      buttonsSliderComponent,
      mode,
    } = this.props;
    let { min, max } = this.props;
    min = parseFloat(min);
    max = parseFloat(max);
    let { type } = this.props;
    if (type !== TYPE_POSITIVE && type !== TYPE_NEGATIVE) {
      type = TYPE_INFORMATION;
    }
    const slider = (
      <div>
        <Segment basic textAlign="center">
          <Slider
            basic={basic}
            settings={{
              min,
              max,
              step,
              onChange,
              start: value,
            }}
            discrete={false}
            inverted={inverted}
            color={color}
            backgroundColor={backgroundColor}
            unit={unit}
            mode={mode}
          />
        </Segment>
        {buttonsSliderComponent && buttonsSliderComponent.length > 0 && (
          <div>{buttonsSliderComponent.map((button) => button.button)}</div>
        )}
      </div>
    );
    return (
      <div>
        <SingleData
          title={title}
          value={slider}
          description={description}
          type={type}
          inverted={inverted}
          showTitleBackground={showBackgroundTitle}
          mode={mode}
        />
      </div>
    );
  }
}

SliderSingleData.propTypes = {
  /* if this variable is false, then the title will have not a background color */
  showBackgroundTitle: PropTypes.bool,
  basic: PropTypes.bool,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.number.isRequired,
  description: PropTypes.string,
  unit: PropTypes.string,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  inverted: PropTypes.bool,
  type: PropTypes.string,
  onChange: PropTypes.func,
  buttonsSliderComponent: PropTypes.arrayOf(Object),
  mode: PropTypes.string,
};

SliderSingleData.defaultProps = {
  showBackgroundTitle: true,
  basic: false,
  color: 'none',
  backgroundColor: 'none',
  title: '',
  description: null,
  unit: '',
  step: 1,
  inverted: false,
  type: '',
  buttonsSliderComponent: null,
  onChange: null,
  mode: null,
};
